
function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return;
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus({ preventScroll: true });

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus({ preventScroll: true });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.product = this.closest('.product');
    this._lastInteraction = null;
    if (this.input) {
      this.input.addEventListener('change', this.onManualInput.bind(this));
      this.input.addEventListener('keyup', this.validateQtyRules.bind(this));
      this.input.addEventListener('input', this.onManualInput.bind(this));
      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          this._lastInteraction = { buttonName: 'input', keyboard: true };
          this.input.blur();
        }
      });
    }
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
    this.isCYOT = this.closest('cart-cyot') !== null;
    if (this.isCYOT) {
      this.input.setAttribute('readonly', 'readonly');
      this.input.setAttribute('tabindex', '-1');
      this.input.style.pointerEvents = 'none';
    }
    this.maxReached = false;
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    this._lastInteraction = { buttonName: event.target.name, keyboard: event.detail === 0 };
    const previousValue = this.input.value;
    event.target.blur();
    if (this.product) {
      this.product.querySelectorAll('quantity-input').forEach((input) => {
        event.target.name === 'plus' ? input.input.stepUp() : input.input.stepDown();
      });
    } else {
      event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    }
    this.handleErrorMessage();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  onManualInput(event) {
    let exceededMax = false;
    if (event.type === 'change') {
      const value = parseInt(this.input.value);
      if (this.input.max) {
        const max = parseInt(this.input.max);
        if (value > max) {
          exceededMax = true;
          this.input.value = max;
        }
      }
      if (this.input.min) {
        const min = parseInt(this.input.min);
        if (value < min || isNaN(value)) {
          this.input.value = min;
        }
      }
    }
    this.validateQtyRules();
    this.handleErrorMessage(exceededMax);
    if (this.product) {
      this.product.querySelectorAll('quantity-input').forEach((quantityInput) => {
        if (quantityInput !== this && quantityInput.input) {
          quantityInput.input.value = this.input.value;
        }
      });
    }
  }

  handleErrorMessage(exceededMax = false) {
    const qtyContainer = this.closest('.product-form__quantity') || this.closest('.quantity-input-container');
    const isCartContext = this.classList.contains('cart-quantity');
    if (exceededMax) {
      if (isCartContext || this.dataset.limit) {
        renderLimitReachedModal('CustomModal-limit-reached');
      } else {
        this.input.classList.add('error');
        if (qtyContainer) {
          if (qtyContainer.querySelector('.error-message')) return;
          const errorElement = document.createElement('div');
          errorElement.classList.add('error-message');
          errorElement.classList.add('show');
          errorElement.textContent = this.dataset.maxError;
          qtyContainer.appendChild(errorElement);
        }
      }
      this.maxReached = true;
    } else {
      this.input.classList.remove('error');
      if (qtyContainer) {
        const errorElement = qtyContainer.querySelector('.error-message');
        if (errorElement) {
          errorElement.classList.remove('show');
          errorElement.remove();
        }
      }
    }
  }

  validateQtyRules() {
    if (!this.input) return;
    const value = parseInt(this.input.value);
    if (this.input.min && !this.isCYOT) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
    if (this.closest('product-info') && this.closest('product-info').querySelector('custom-modal-opener'))
      this.closest('product-info').querySelector('custom-modal-opener').setAttribute('data-quantity', value);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents(this);
  }

  bindEvents(target) {
    target
      .querySelectorAll('summary')
      .forEach((summary) => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    target
      .querySelectorAll('button:not(.localization-selector)')
      .forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    this.bindEvents(summaryElement.nextElementSibling);
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }
    if (detailsElement === this.mainDetailsToggle) {
      const closeButton = this.querySelector('.mobile-facets__close');
      if (closeButton) {
        const that = this;
        closeButton.addEventListener('click', function (event) {
          that.closeMenuDrawer(event, summaryElement);
        });
        closeButton.addEventListener('keydown', function (event) {
          if (event.key === 'Enter' || event.key === ' ') {
            that.closeMenuDrawer(event, summaryElement);
          }
        });
      }
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        this.mainDetailsToggle.classList.add('submenu-open');
        detailsElement.classList.add('menu-opening');
        document.querySelectorAll('.menu-drawer__close-button').forEach(function (close) {
          if (close.classList.contains('active')) close.classList.remove('active');
        });
        detailsElement.querySelector('button').classList.add('active');
        if (detailsElement.classList.value.includes('facet')) initSlider(true);
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    const cartCYOT = document.querySelector('#cart-cyot');
    if (cartCYOT) cartCYOT.classList.add('menu-open');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.classList.remove('submenu-open');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
    const cartCYOT = document.querySelector('#cart-cyot');
    if (cartCYOT) cartCYOT.classList.remove('menu-open');
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    if (!event.currentTarget.classList.contains('active')) return;
    event.currentTarget.classList.remove('active');
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
    detailsElement.closest('.menu-drawer__inner-submenu')?.querySelector('button').classList.add('active');
  }

  closeSubmenu(detailsElement) {
    const parentDetailsElement = detailsElement.parentElement.closest('details');
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentDetailsElement.getAttribute('id') === 'Details-menu-drawer-container' &&
      parentDetailsElement.classList.remove('submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  updateHeaderPositionVars = () => {
    if (!this.header) return;
    const rect = this.header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(rect.bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--header-top-position', `${Math.max(0, parseInt(rect.top))}px`);
  };

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.header.classList.add('menu-open');
    this.updateHeaderPositionVars();
    requestAnimationFrame(this.updateHeaderPositionVars);

    if ('ResizeObserver' in window) {
      this.headerResizeObserver = this.headerResizeObserver || new ResizeObserver(this.updateHeaderPositionVars);
      this.headerResizeObserver.observe(this.header);
    }
    if ('MutationObserver' in window) {
      this.headerMutationObserver =
        this.headerMutationObserver ||
        new MutationObserver(() => {
          if (this.headerVarsRaf) return;
          this.headerVarsRaf = requestAnimationFrame(() => {
            this.headerVarsRaf = null;
            this.updateHeaderPositionVars();
          });
        });
      this.headerMutationObserver.observe(document.body, { childList: true, subtree: true });
    }

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    const facetsWrapper = document.querySelector('.facets-wrapper');
    if (facetsWrapper) facetsWrapper.classList.add('menu-open');
    const cartCYOT = document.querySelector('#cart-cyot');
    if (cartCYOT) cartCYOT.classList.add('menu-open');
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
    if (this.headerResizeObserver) this.headerResizeObserver.disconnect();
    if (this.headerMutationObserver) this.headerMutationObserver.disconnect();
    if (this.headerVarsRaf) {
      cancelAnimationFrame(this.headerVarsRaf);
      this.headerVarsRaf = null;
    }
    const facetsWrapper = document.querySelector('.facets-wrapper');
    if (facetsWrapper) facetsWrapper.classList.remove('menu-open');
    const cartCYOT = document.querySelector('#cart-cyot');
    if (cartCYOT) cartCYOT.classList.remove('menu-open');
  }

  onResize = () => {
    this.updateHeaderPositionVars();
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    const required = this.hasAttribute('required');
    const closeBtns = this.querySelectorAll('[id^="ModalClose-"]');
    if (closeBtns.length > 0 && !required) {
      closeBtns.forEach((closeBtn) => closeBtn.addEventListener('click', this.hide.bind(this, false)));
    }
    if (!required) {
      this.addEventListener('keyup', (event) => {
        if (event.code && event.code.toUpperCase() === 'ESCAPE' && !this.hasAttribute('required')) this.hide();
      });
    }
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else if (!required) {
      this.addEventListener('click', (event) => {
        if (event.target === this && !this.hasAttribute('required')) this.hide();
      });
    }
    const modalContent = this.querySelector('.custom-modal__content-info');
    if (modalContent && modalContent.textContent.includes('iframe')) {
      modalContent.innerHTML = modalContent.textContent.trim();
    }
    if (modalContent && modalContent.classList.contains('no-image')) {
      modalContent.style.maxHeight = window.innerHeight - 100 + 'px';
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    const iframe = this.querySelector('iframe');
    if (iframe) {
      const url = new URL(iframe.src);
      url.searchParams.set('t', new Date().getTime());
      iframe.src = url.toString();
    }
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    handleScrollOnModalToggle(true, this);
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    const isRedirectModal = this.id.includes('redirect');
    if (isRedirectModal) {
      Cookies.set('redirect', 'false', { expires: 365 });
    }
    handleScrollOnModalToggle(false, this);
    this.removeAttribute('open');
    if (this.openedBy) removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    if (this.dataset.name === 'Newsletter') this.remove();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const modalID = this.getAttribute('data-modal');
    const target = this.children[0];
    if (!modalID) return;
    if (window.isTouchDevice() && this.classList.contains('product__modal-opener--image')) {
      this.addEventListener('click', () => {
        const modal = document.querySelector(modalID);
        if (modal) modal.show(this);
      });
    } else if (target) {
      target.addEventListener('click', () => {
        const modal = document.querySelector(modalID);
        if (modal) modal.show(target);
      });
    }
  }
}

if (document.body.classList.contains('has-optimizely')) {
  document.body.addEventListener('optimizely-ready', () => {
    if (customElements.get('modal-opener') === undefined) customElements.define('modal-opener', ModalOpener);
  });
} else {
  if (customElements.get('modal-opener') === undefined) customElements.define('modal-opener', ModalOpener);
}

class SizeGuide extends HTMLElement {
  constructor() {
    super();
    const defaultImperialCountries = ['US', 'LR', 'MM'];
    this.sizeToggle = this.querySelector('#size-toggle');
    this.inchTable = this.querySelector('table.inch');
    this.cmTable = this.querySelector('table.cm');
    if (this.inchTable && this.cmTable) {
      this.inchTable.classList.add('inches');
      this.cmTable.classList.add('cm');
    }
    if (this.sizeToggle) {
      this.sizeToggle.addEventListener('click', this.handleSizeToggle);
    }

    this.tablesContainer = this.querySelector('.size-guide-tables-container');
    if (this.tablesContainer) {
      this.tablesContainer.addEventListener('scroll', this.handleTableScroll);
      this.handleTableScroll();
    }

    if (window?.Shopify?.country && !defaultImperialCountries.includes(window.Shopify.country)) {
      this.handleSizeToggle();
    }
  }

  handleTableScroll = () => {
    const scrollLeft = this.tablesContainer.scrollLeft;
    const tables = this.tablesContainer.querySelectorAll('table');

    if (scrollLeft > 0) {
      tables.forEach((table) => table.classList.add('is-scrolled'));
    } else {
      tables.forEach((table) => table.classList.remove('is-scrolled'));
    }
  };

  handleSizeToggle = (e) => {
    if (e) e?.preventDefault();
    this.classList.toggle('display-inches');
    const circle = this.sizeToggle.querySelector('circle');
    if (circle) {
      if (this.classList.contains('display-inches')) {
        circle.setAttribute('cx', '32');
      } else {
        circle.setAttribute('cx', '10.5469');
      }
    }
  };
}
customElements.define('size-guide', SizeGuide);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        deferredElement.play(); // Safari requires a play() call after injecting autoplay video.
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this._initTimeoutId = setTimeout(() => {
      this._initTimeoutId = null;
      this.slider = this.querySelector('[id^="Slider-"]');
      this.sliderItems = this.slider.querySelectorAll(':scope > [id^="Slide-"]');
      this.enableSliderLooping = false;
      this.currentPageElement = this.querySelector('.slider-counter--current');
      this.pageTotalElement = this.querySelector('.slider-counter--total');
      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      if (!this.slider || !this.nextButton) return;

      this.initPages();
      this._initPagesPending = false;
      var self = this;
      this._resizeObserver = new ResizeObserver(function () {
        if (self._initPagesPending) return;
        self._initPagesPending = true;
        requestAnimationFrame(function () {
          self._initPagesPending = false;
          if (!self.isConnected || !self.slider) return;
          self.initPages();
        });
      });
      this._resizeObserver.observe(this.slider);

      this._scrollHandler = this.update.bind(this);
      this._prevClickHandler = this.onButtonClick.bind(this);
      this._nextClickHandler = this.onButtonClick.bind(this);
      this.slider.addEventListener('scroll', this._scrollHandler);
      this.prevButton.addEventListener('click', this._prevClickHandler);
      this.nextButton.addEventListener('click', this._nextClickHandler);

      if (this.id.includes('GalleryViewer')) {
        this._gallerySlideScrollHandler = this.onSlide.bind(this);
        this._gallerySlideTouchHandler = this.onSlide.bind(this);
        this.slider.addEventListener('scroll', this._gallerySlideScrollHandler, { once: true });
        this.slider.addEventListener('touchmove', this._gallerySlideTouchHandler, { once: true });
      }
    }, 300);
  }

  disconnectedCallback() {
    if (this._initTimeoutId) {
      clearTimeout(this._initTimeoutId);
      this._initTimeoutId = null;
    }
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
    if (this.slider) {
      if (this._scrollHandler) this.slider.removeEventListener('scroll', this._scrollHandler);
      if (this._gallerySlideScrollHandler) this.slider.removeEventListener('scroll', this._gallerySlideScrollHandler);
      if (this._gallerySlideTouchHandler) this.slider.removeEventListener('touchmove', this._gallerySlideTouchHandler);
    }
    if (this.prevButton && this._prevClickHandler) {
      this.prevButton.removeEventListener('click', this._prevClickHandler);
    }
    if (this.nextButton && this._nextClickHandler) {
      this.nextButton.removeEventListener('click', this._nextClickHandler);
    }
    this._scrollHandler = null;
    this._prevClickHandler = null;
    this._nextClickHandler = null;
    this._gallerySlideScrollHandler = null;
    this._gallerySlideTouchHandler = null;
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);

    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    if (!this.slider) return false;
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }

  onSlide() {
    const productInfo = this.parentElement.dataset.gpo ? this.parentElement : document.querySelector('product-info');
    const gpo = JSON.parse(productInfo.dataset.gpo)
    const productId = gpo.id;
    if (gpo.media.length > this.sliderItems.length) {
      gpo.media.slice(2).forEach((image) => {
        const slideElement = this.sliderItems[1].cloneNode(true);
        slideElement.id = `Slide-${productId}-${image.id}`;
        slideElement.dataset.mediaId = `${productId}-${image.id}`;
        let imgElement = slideElement.querySelector('img');
        imgElement.src = image.src;
        imgElement.alt = image.alt || '';
        imgElement.width = image.width;
        imgElement.height = image.height;
        imgElement.id = image.src;
        this.slider.appendChild(slideElement);
      });
    }
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.setup = this.setup.bind(this);
    this._setupTimeoutId = setTimeout(() => {
      this._setupTimeoutId = null;
      this.setup();
    }, 500);
  }

  disconnectedCallback() {
    if (this._setupTimeoutId) {
      clearTimeout(this._setupTimeoutId);
      this._setupTimeoutId = null;
    }
    if (this._reducedMotionMql && this._reducedMotionHandler) {
      this._reducedMotionMql.removeEventListener('change', this._reducedMotionHandler);
      this._reducedMotionMql = null;
      this._reducedMotionHandler = null;
    }
    super.disconnectedCallback();
  }

  setup() {
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;
    if (!this.slider) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0; // Must match --duration-announcement-bar in CSS.

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._reducedMotionMql = this.reducedMotion;
      this._reducedMotionHandler = () => {
        if (this.slider && this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      };
      this.reducedMotion.addEventListener('change', this._reducedMotionHandler);

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
    else if (this.slider.classList.contains('slideshow-has-video')) this.setVideoPausePlayHandler();

    this.startX = 0;

    this.minSwipeDistance = 50;

    this.isScrolling = false;
    this.scrollTimer = null;

    if (!this.announcementBarSlider) this.handleVideoSlide();

    const throttledHandleWheel = throttle(this.handleWheel, 500);
    this.slider.addEventListener('touchmove', this.handleTouchMove, { passive: false });
    this.slider.addEventListener('scroll', this.handleScroll, { passive: false });
    this.slider.addEventListener('touchstart', this.handleTouchStart, { passive: false });
    this.slider.addEventListener('touchend', this.handleTouchEnd, { passive: false });
    this.slider.addEventListener('mousedown', this.handleMouseDown, { passive: false });
    this.slider.addEventListener('mouseup', this.handleMouseUp, { passive: false });
    this.slider.addEventListener('wheel', throttledHandleWheel, { passive: false });
  }

  handleVideoSlide = () => {
    const currentSlide = this.sliderItemsToShow[this.currentPage - 1];
    if (!currentSlide) return;
    const videoSlide = currentSlide.querySelector('video');
    if (currentSlide && videoSlide) {
      this.slider.parentElement.classList.add('has-video');
      if (videoSlide.paused && !this.sliderAutoplayButton.classList.contains('slideshow__autoplay--paused')) {
        if (videoSlide.readyState >= 2) {
          videoSlide.play();
        } else {
          videoSlide.addEventListener(
            'canplay',
            () => {
              videoSlide.play();
            },
            { once: true }
          );
        }
      } else if (videoSlide.paused && this.sliderAutoplayButton.classList.contains('slideshow__autoplay--paused')) {
        if (videoSlide.readyState >= 2) {
          videoSlide.pause();
        } else {
          videoSlide.addEventListener(
            'play',
            () => {
              videoSlide.pause();
            },
            { once: true }
          );
        }
      } else if (!videoSlide.paused && this.sliderAutoplayButton.classList.contains('slideshow__autoplay--paused')) {
        if (videoSlide.readyState >= 2) {
          videoSlide.pause();
        } else {
          videoSlide.addEventListener(
            'play',
            () => {
              videoSlide.pause();
            },
            { once: true }
          );
        }
      }
    } else {
      this.slider.parentElement.classList.remove('has-video');
    }
  };

  handleTouchMove = (event) => {
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
    if (
      (isFirstSlide && event.touches[0].clientX > this.startX) ||
      (isLastSlide && event.touches[0].clientX < this.startX) ||
      this.slider.scrollLeft < 0 ||
      this.slider.scrollLeft + this.slider.clientWidth > this.slider.scrollWidth
    ) {
      event.preventDefault();
      this.isScrolling = false;
    }
  };

  handleScroll = (event) => {
    if (this.scrollTimer) clearTimeout(this.scrollTimer);
    if (this.slider.scrollLeft < 0 || this.slider.scrollLeft + this.slider.clientWidth > this.slider.scrollWidth) {
      this.isScrolling = false;
      event.preventDefault();
    } else {
      this.isScrolling = true;
      this.scrollTimer = setTimeout(() => {
        this.isScrolling = false;
        this.handleVideoSlide();
      }, 100);
    }
    if (this.slider.getAttribute('aria-live') === 'off') this.play();
  };

  handleWheel = (event) => {
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
    if (!this.isScrolling) {
      if (isFirstSlide && event.deltaX < 0) {
        event.preventDefault();
        this.onButtonClick({
          currentTarget: this.prevButton,
          preventDefault: () => {},
        });
      } else if (isLastSlide && event.deltaX > 0) {
        event.preventDefault();
        this.onButtonClick({
          currentTarget: this.nextButton,
          preventDefault: () => {},
        });
      } else {
        setTimeout(() => this.handleVideoSlide(), 500);
      }
    }
  };

  handleMouseDown = (event) => {
    this.startX = event.clientX;
    clearInterval(this.autoplay);
  };

  handleMouseUp = (event) => {
    const endX = event.clientX;
    const deltaX = this.startX - endX;

    if (Math.abs(deltaX) > this.minSwipeDistance && !this.isScrolling) {
      if (deltaX > 0) {
        event.preventDefault();
        this.onButtonClick({
          currentTarget: this.nextButton,
          preventDefault: () => {},
        });
      } else if (deltaX < 0) {
        event.preventDefault();
        this.onButtonClick({
          currentTarget: this.prevButton,
          preventDefault: () => {},
        });
      }
      setTimeout(() => this.handleVideoSlide(), 500);
    }
  };

  handleTouchStart = (event) => {
    this.startX = event.touches[0].clientX;
    clearInterval(this.autoplay);
  };

  handleTouchEnd = (event) => {
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;
    const endX = event.changedTouches[0].clientX;
    const deltaX = this.startX - endX;

    if (Math.abs(deltaX) > this.minSwipeDistance && !this.isScrolling) {
      if (deltaX > 0 && isLastSlide) {
        event.preventDefault();
        this.onButtonClick({
          currentTarget: this.nextButton,
          preventDefault: () => {},
        });
      } else if (deltaX < 0 && isFirstSlide) {
        event.preventDefault();
        this.onButtonClick({
          currentTarget: this.prevButton,
          preventDefault: () => {},
        });
      } else {
        setTimeout(() => this.handleVideoSlide(), 500);
      }
    }
  };

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  setVideoPausePlayHandler = () => {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    if (this.sliderAutoplayButton) {
      this.sliderAutoplayButton.addEventListener('click', this.handleVideoPausePlay.bind(this));
    }
  };

  handleVideoPausePlay = () => {
    const currentSlide = this.sliderItemsToShow[this.currentPage - 1];
    const videoSlide = currentSlide.querySelector('video');
    if (videoSlide) {
      if (this.sliderAutoplayButton.classList.contains('slideshow__autoplay--paused')) {
        this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseVideo);
        videoSlide.play();
      } else {
        videoSlide.pause();
        this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
        this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playVideo);
      }
    }
  };

  onButtonClick = (event) => {
    throttle(this.buttonClick, 500).call(this, event);
  };

  buttonClick = (event) => {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide && this.announcementBarSlider) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.slideScrollPosition = Number.isNaN(this.slideScrollPosition) ? 0 : this.slideScrollPosition;

    this.setSlidePosition(this.slideScrollPosition);
    if (this.slider.getAttribute('data-autoplay') === 'true') this.play();

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  };

  setSlidePosition(position) {
    let left = position;
    let behavior = 'auto';
    if (position < 0) {
      left = 0;
      this.currentPage = 1;
      behavior = 'instant';
    } else if (position > this.slider.scrollWidth - 200) {
      left = this.slider.scrollWidth - this.slider.clientWidth;
      this.currentPage = this.sliderItems.length;
      behavior = 'instant';
    }

    if (this.announcerBarAnimationDelay === 0) {
      this.slider.scrollTo({
        left,
        behavior,
      });
    } else {
      if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
      this.setPositionTimeout = setTimeout(() => {
        this.slider.scrollTo({
          left,
          behavior,
        });
      }, this.announcerBarAnimationDelay);
    }

    if (this.slider.getAttribute('aria-live') === 'off') this.play();
    if (!this.announcementBarSlider) setTimeout(() => this.handleVideoSlide(), 500);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    const currentSlideControl = this.sliderControlButtons[this.currentPage - 1];
    currentSlideControl.classList.add('slider-counter__link--active');
    currentSlideControl.setAttribute('aria-current', true);
    this.handleThemeUpdate(currentSlideControl);
  }

  handleThemeUpdate(currentSlideControl) {
    const slideControlWrapper = currentSlideControl.parentElement;
    const currentSlideTheme = Array.from(currentSlideControl.classList).find((className) =>
      className.includes('current-slide-theme--')
    );
    if (currentSlideTheme) {
      const slideThemes = ['default', 'dark', 'light'];
      const themedElements = Array.from(this.querySelectorAll('.slider-button'));
      themedElements.push(slideControlWrapper);
      themedElements.forEach((element) => {
        slideThemes.forEach((theme) => {
          element.classList.remove(`slide-theme--${theme}`);
          element.classList.add(currentSlideTheme.replace('current-', ''));
        });
      });
    }
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    if (this.slider.getAttribute('aria-live') === 'polite') return;

    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    if (!Number.isNaN(slideScrollPosition)) {
      this.setSlidePosition(slideScrollPosition);
      this.applyAnimationToAnnouncementBar();
    }
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.radioCount = this.querySelectorAll('input').length;
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.handleQuickShopMobileModalSize();

    if (this.currentVariant) {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  handleQuickShopMobileModalSize() {
    if (window.innerWidth >= window.MOBILE_BREAKPOINT) return;
    setTimeout(() => {
      const modal = this.closest('.quick-add-modal[open]');
      if (!modal) return;
      const modalContentWrapper = modal.querySelector('.quick-add-modal__content');
      const modalContent = modalContentWrapper.querySelector('.quick-add-modal__content-info .product');
      const modalHeight = Math.min(modalContent.scrollHeight + 37, window.innerHeight);
      if (modalHeight < window.innerHeight) {
        modalContentWrapper.classList.add('quick-add-modal--fit');
      }
      modalContentWrapper.style.height = `${modalHeight}px`;
    }, 100);
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      const modalOpener = productForm.querySelector('custom-modal-opener');
      if (modalOpener) modalOpener.dataset.variantId = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      if (!inputWrappers[index - 1].querySelector(':checked')) return;
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const productContainer = this.closest('.product');
    if (!productContainer) return;

    const productForm = productContainer.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage('', false);
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const disable = this.currentVariant.available == false && this.classList.contains('no-notify-me');
        const text = disable ? 'sold-out' : null;
        this.toggleAddButton(disable, text);

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    if (text === 'sold-out') this.closest('.product').classList.add('variant-unavailable');
    else if (!disable) this.closest('.product').classList.remove('variant-unavailable');
    if (this.radioCount === 1) return;
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]') || productForm.querySelector('[name="personalize"]');
    if (!addButton) return;
    const addButtonText = addButton.querySelector('span');
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text && addButtonText) {
        if (text === 'sold-out') {
          const soldOutText = addButton.getAttribute('data-sold-out-text');
          if (soldOutText) addButtonText.textContent = soldOutText;
        } else {
          addButtonText.textContent = text;
        }
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.classList.remove('hidden');
      const textAttribute = addButton.getAttribute('data-add-to-cart-text');
      if (textAttribute && addButtonText) {
        addButtonText.textContent = textAttribute;
      }
    }
    handleSubmitState();
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
    this.numberOfVariantGroups = this.querySelectorAll('fieldset').length;
    const queryString = window.location.search;
    const productContainer = this.closest('.product');
    const notifyMe = productContainer ? productContainer.querySelector('product-notification') : document.querySelector('product-notification');
    const selectedVariant = this.querySelector('input[type = "radio"]:checked');
    if (selectedVariant) {
      if (notifyMe && selectedVariant.classList.contains('disabled')) notifyMe.detectSelectedVariant();
      this.toggleAddButton(selectedVariant.classList.contains('disabled'), '', true);
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else if (listOfAvailableOptions.length) {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    this.options = [];
    this.querySelectorAll('fieldset').forEach((fieldset) => {
      Array.from(fieldset.querySelectorAll('input')).forEach((radio) => {
        if (radio.checked) {
          this.options.push(radio.value);
        }
      });
    });
    this.handleErrorMessage();
  }

  handleErrorMessage() {
    let valid = true;
    const noSizeSelected = this.querySelectorAll('input[type=radio]:checked').length !== this.numberOfVariantGroups;
    this.querySelectorAll('fieldset').forEach((fieldset) => {
      const selected = fieldset.querySelectorAll('input[type=radio]:checked').length === 1;
      if (!selected) {
        valid = false;
        if (fieldset.classList.contains('highlight')) {
          fieldset.classList.remove('highlight');
          fieldset.classList.add('error');
        } else {
          fieldset.classList.add('highlight');
        }
        if (window.innerWidth < window.MOBILE_BREAKPOINT)
          fieldset.scrollIntoView({ behavior: 'smooth', block: 'center' });
      } else {
        fieldset.classList.remove('highlight', 'error');
      }
    });
    if (!noSizeSelected) {
      valid = true;
      this.classList.remove('highlight', 'error');
    }
    return valid;
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products') &&
            !this.classList.contains('complementary-products-contains-quick-add')
          ) {
            this.remove();
          }

          if (this.querySelector('.grid__item') && !this.querySelector('.complementary-products__container')) {
            this.classList.add('product-recommendations--loaded');
            document.dispatchEvent(new CustomEvent('recommendations-loaded'));
          }

          if (this.querySelector('.complementary-products__container')) {
            this.equalizeComplementaryCardHeights();

            this.resizeHandler = this.debounce(() => {
              this.equalizeComplementaryCardHeights();
            }, 150);
            window.addEventListener('resize', this.resizeHandler);

            document.dispatchEvent(
              new CustomEvent('complementary-products-loaded', {
                detail: {
                  products: Array.from(this.querySelectorAll('.complementary-card')).map((card) => ({
                    productId: card.dataset.productId,
                    productUrl: card.dataset.productUrl,
                  })),
                },
              })
            );
          }

          if (typeof globalThis.convertToUserCurrency === 'function') convertToUserCurrency(true);
        })
        .catch((e) => {
          console.error(e);
        });
    };

    this._intersectionObserver = new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    });
    this._intersectionObserver.observe(this);
  }

  equalizeComplementaryCardHeights() {
    const cards = this.querySelectorAll('.complementary-card .complementary-card__inner');
    if (cards.length === 0) return;

    cards.forEach((card) => {
      card.style.minHeight = 'auto';
    });

    let maxHeight = 0;
    cards.forEach((card) => {
      const cardHeight = Math.floor(card.getBoundingClientRect().height);
      if (cardHeight > maxHeight) {
        maxHeight = cardHeight;
      }
    });

    cards.forEach((card) => {
      card.style.minHeight = `${maxHeight}px`;
    });
  }

  debounce(func, wait) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), wait);
    };
  }

  disconnectedCallback() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
      this.resizeHandler = null;
    }
    if (this._intersectionObserver) {
      this._intersectionObserver.disconnect();
      this._intersectionObserver = null;
    }
  }
}

customElements.define('product-recommendations', ProductRecommendations);

const handleProductThumbs = (that, src) => {
  const cardImage = that.closest('.card').querySelector('.media img');
  const firstImage = cardImage.dataset.firstImage;
  cardImage.src = src;
  Array.from(that.parentNode.querySelectorAll('button')).forEach((thumb) => {
    thumb.classList.remove('active');
  });
  that.classList.add('active');
};

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
window.isTouchDevice = isTouchDevice;

class WishlistButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    var eventName = isTouchDevice() ? 'touchstart' : 'click';
    this.button.addEventListener(eventName, this.onButtonClick.bind(this));
    this.handle = this.button.getAttribute('data-handle');
    this.updateWishlistStatus();
  }
  updateWishlistStatus() {
    var existIndex = this.getWishlist().indexOf(this.handle);
    if (existIndex !== -1) this.button.classList.add('added');
  }
  getWishlist() {
    var wishlist = Cookies.get('wishlist');
    if (wishlist) {
      wishlist = JSON.parse(wishlist);
    } else {
      wishlist = [];
    }
    return wishlist;
  }
  onButtonClick(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.classList.contains('card__wishlist')) this.productData = this.closest('.card').querySelector('a');
    else if (this.closest('.buy-buttons-container')?.classList?.contains('fixed'))
      this.productData = document.querySelector('product-info');
    else if (this.classList.contains('productPage__wishlist')) this.productData = this.closest('product-info');
    else this.productData = this;
    this.removeOrAdd(this.handle);

    var wishlistPage = document.getElementById('wishlist');
    if (wishlistPage) location.reload();
  }
  removeOrAdd() {
    var OnetrustActiveGroups = window?.OnetrustActiveGroups;
    var wishlistStored = this.getWishlist();
    var existIndex = wishlistStored.indexOf(this.handle);
    if (existIndex !== -1) {
      document.querySelectorAll(`wishlist-button button[data-handle="${this.handle}"]`).forEach((btn) => {
        btn.classList.remove('added');
      });
      if (OnetrustActiveGroups?.indexOf(',tc,') !== -1) {
        this.track('removeWishlist');
      }
      wishlistStored.splice(existIndex, 1);
    } else {
      document.querySelectorAll(`wishlist-button button[data-handle="${this.handle}"]`).forEach((btn) => {
        btn.classList.add('added');
      });
      if (OnetrustActiveGroups?.indexOf(',tc,') !== -1) {
        this.track('addWishlist');
      }
      wishlistStored.push(this.handle);
    }
    Cookies.set('wishlist', JSON.stringify(wishlistStored), 30);
  }
  track(name) {
    var parsedDataSet = {};
    if (this.productData.dataset.gpo) {
      parsedDataSet = convertGPOForGA(JSON.parse(this.productData.dataset.gpo), true);
    } else if (this.productData.dataset.cartGpo) {
      parsedDataSet = convertCartGPOForGA(JSON.parse(this.productData.dataset.cartGpo), true);
    } else {
      console.error(`analytics on wishlist event: ${name} unseccessful, general product object invalid.`);
    }

    if (window.segmentEventPublish) {
      segmentEventPublish({
        segmentType: name,
        product: parsedDataSet,
      });
    }
  }
}
customElements.define('wishlist-button', WishlistButton);

const tabLinks = document.querySelectorAll('.tabs__title');
const tabContents = document.querySelectorAll('.tabs__content');
const tabDescriptions = document.querySelectorAll('.tabs__description');

tabContents.forEach((content, index) => {
  tabDescriptions[index].innerHTML = content.innerHTML;
});

tabLinks.forEach((tabLink) => {
  tabLink.addEventListener('click', (e) => {
    e.preventDefault();
    tabLinks.forEach((t) => t.parentElement.classList.remove('active'));
    tabLink.parentElement.classList.add('active');

    tabContents.forEach((content) => content.classList.remove('active'));
    const index = Array.from(tabLinks).indexOf(tabLink);
    tabContents[index].classList.add('active');

    const icons = document.querySelectorAll('.tabs__accordions .icon');
    icons.forEach((icon) => {
      icon.classList.remove('icon--minus');
      icon.classList.add('icon--plus');
    });

    const icon = tabLink.querySelector('.icon');
    icon.classList.remove('icon--plus');
    icon.classList.add('icon--minus');
  });
});

const actionViewDetails = document.querySelector('.action--view-details');

if (actionViewDetails) {
  actionViewDetails.addEventListener('click', function (event) {
    event.preventDefault();

    let navHeight = 0;
    const announcementBar = document.querySelector('.announcement-bar-section');
    const navigation = document.querySelector('.header, .header-new'); // Header 2.0 uses .header-new, not .header.
    navHeight = navigation?.offsetHeight || 0;

    navHeight += document.querySelector('.mobile-search')?.offsetHeight || 0;

    if (window.innerWidth < window.MOBILE_BREAKPOINT) {
      navHeight += announcementBar?.offsetHeight || 0;
    }

    const tabs = document.querySelector('.tabs');
    if (!tabs) {
      return;
    }
    const tabsOffset = tabs.offsetTop - navHeight;
    window.scrollTo({
      top: tabsOffset,
      behavior: 'smooth',
    });
  });
}

function getSite() {
  const url = document.querySelector("meta[property~='og:url']").getAttribute('content');

  const domain = url.split('/')[2];
  switch (true) {
    case domain.includes('uk'):
      return 'uk';
    case domain.includes('jp'):
      return 'jp';
    case !domain.includes('uk') && !domain.includes('jp'):
      return 'us';
  }
}

function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
  const [from, to] = getParsed(fromInput, toInput);
  fillSlider(fromInput, toInput, '#C6C6C6', '#aa8855', controlSlider);
  if (from > to) {
    fromSlider.value = to;
    fromInput.value = to;
  } else {
    fromSlider.value = from;
  }
  fromSlider.min = fromInput.min;
}

function controlToInput(toSlider, fromInput, toInput, controlSlider) {
  const [from, to] = getParsed(fromInput, toInput);
  fillSlider(fromInput, toInput, '#C6C6C6', '#aa8855', controlSlider);
  setToggleAccessible(toInput);
  if (from <= to) {
    toSlider.value = to;
    toInput.value = to;
  }
  toSlider.max = toInput.max;
  toSlider.value = toInput.value;
}

function controlFromSlider(fromSlider, toSlider, fromInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  const priceRange = document.querySelector('price-range');
  priceRange.adjustToValidValues(fromInput);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#aa8855', toSlider);
  if (from > to) {
    fromSlider.value = to;
    fromInput.value = to;
  } else {
    fromInput.value = from;
  }
  fromSlider.min = fromInput.min;
}

function controlToSlider(fromSlider, toSlider, toInput) {
  const [from, to] = getParsed(fromSlider, toSlider);
  const priceRange = document.querySelector('price-range');
  priceRange.adjustToValidValues(toInput);
  fillSlider(fromSlider, toSlider, '#C6C6C6', '#aa8855', toSlider);
  setToggleAccessible(toSlider);
  if (from <= to) {
    toSlider.value = to;
    toInput.value = to;
  } else {
    toInput.value = from;
    toSlider.value = from;
  }
  toSlider.max = toInput.max;
}

function getParsed(currentFrom, currentTo) {
  const from = parseInt(currentFrom.value, 10);
  const to = parseInt(currentTo.value, 10);
  return [from, to];
}

function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
  const rangeDistance = to.max - to.min;
  const fromPosition = from.value - to.min;
  const toPosition = to.value - to.min;
  controlSlider.style.background = `linear-gradient(
    to right,
    ${sliderColor} 0%,
    ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
    ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
    ${rangeColor} ${(toPosition / rangeDistance) * 100}%, 
    ${sliderColor} ${(toPosition / rangeDistance) * 100}%, 
    ${sliderColor} 100%)`;
}

function setToggleAccessible(currentTarget) {
  const toSlider = document.querySelector('#toSlider');
  if (Number(currentTarget.value) <= 0) {
    toSlider.style.zIndex = 2;
  } else {
    toSlider.style.zIndex = 0;
  }
}

function initSlider(mobile) {
  const fromSliderId = mobile ? '#fromSliderMobile' : '#fromSlider';
  const toSliderId = mobile ? '#toSliderMobile' : '#toSlider';
  const fromInputId = mobile ? '#Mobile-Filter-Price-GTE' : '#Filter-Price-GTE';
  const toInputId = mobile ? '#Mobile-Filter-Price-LTE' : '#Filter-Price-LTE';
  const fromSlider = document.querySelector(fromSliderId);
  const toSlider = document.querySelector(toSliderId);
  const fromInput = document.querySelector(fromInputId);
  const toInput = document.querySelector(toInputId);

  if (fromSlider && toSlider && fromInput && toInput) {
    fillSlider(fromSlider, toSlider, '#C6C6C6', '#aa8855', toSlider);
    setToggleAccessible(toSlider);
    fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
    toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
    fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
    toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);
  }
}
initSlider();


function handleSubmitState() {
  const quickAddModal = document.querySelector('quick-add-modal[open]');
  const quickAddModalActive = quickAddModal ? quickAddModal.getAttribute('open') === '' : false;
  const pField = quickAddModalActive ? quickAddModal.querySelector('#pfield') : document.querySelector('#pfield');
  const mpFields = quickAddModalActive ? quickAddModal.querySelector('#mpfields') : document.querySelector('#mpfields');
  const pcField = quickAddModalActive ? quickAddModal.querySelector('#pcfield') : document.querySelector('#pcfield');

  if (pField || mpFields || pcField) {
    const productInfo = (pField || mpFields || pcField).closest('product-info');
    const submitButton = quickAddModalActive ? quickAddModal.querySelector('button[name="add"]') : document.querySelector('button[name="add"]');
    const productForm = submitButton.closest('product-form');
    let isValid = true;

    if (pField) {
      const pFieldInput = pField.querySelector('#pfield-input');
      let fieldValue = '';
      if (pFieldInput) {
        fieldValue = pFieldInput.value;
      }
      isValid = validatePField(fieldValue, pField);
      if (isValid) {
        pField.querySelectorAll('.highlight').forEach((field) => {
          field.classList.remove('highlight');
        });
        pField.querySelectorAll('.error').forEach((field) => {
          field.classList.remove('error');
        });
      }
    } else if (mpFields) {
      const mpFieldInputs = mpFields.querySelectorAll('input.field__input');
      const mpFieldSelects = mpFields.querySelectorAll('select');
      mpFieldInputs.forEach((input) => {
        isValid = isValid && validateFormField(input);
      });
      mpFieldSelects.forEach((select) => {
        isValid = isValid && !!select.value;
      });
    } else if (pcField) {
      const pcFieldInput = pcField.querySelector('#pfield-input');
      let fieldValue = '';
      if (pcFieldInput) {
        fieldValue = pcFieldInput.value;
      }
      isValid = validatePField(fieldValue, pcField);
    }
    if (!productForm) return;
    if (isValid && submitButton) {
      submitButton.disabled = false;
      productForm.dataset.valid = 'true';
    } else if (!isValid && submitButton) {
      productForm.dataset.valid = 'false';
    }
  }
}



function validateFormField(field) {
  if (field) {
    const maxLength = field.getAttribute('maxlength');
    const fieldValue = field.value;
    if (maxLength > 0 && fieldValue.length > maxLength) {
      return false;
    }
    const patternString = field.getAttribute('pattern');
    const pattern = new RegExp(patternString);
    if (!pattern) return true;
    const capitalize = field.getAttribute('capitalize');
    const isValid = pattern.test(capitalize ? (fieldValue || '').toUpperCase() : fieldValue);
    return isValid;
  }
  return false;
}

function validatePField(fieldValue, pfield) {
  if (pfield) {
    const pfieldInput = pfield.querySelector('#pfield-input');
    const noPersCheck = pfield.querySelector('#no-personalization');
    const patternString = pfieldInput.getAttribute('pattern');
    const pattern = new RegExp(patternString);
    if (!pattern || (noPersCheck && !fieldValue && noPersCheck.checked)) {
      return true;
    }
    const capitalize = pfieldInput.getAttribute('capitalize');
    const isValid = pattern.test(capitalize ? (fieldValue || '').toUpperCase() : fieldValue);
    return isValid;
  }
}

async function getCart() {
  var cart = await fetch('/cart.js')
    .then(function (response) {
      return response.json();
    })
    .catch(function (e) {
      console.warn(e.message);
    });
  return cart;
}

async function cartAction(task, data, options = {}) {
  let dataWithSections = data;
  const cartItems = document.querySelector('cart-cyot-items') || document.querySelector('cart-items');
  const cartDrawer = document.querySelector('cart-drawer');

  if (task !== 'update_status') {
    if (cartItems) {
      let sections = [];
      cartItems.getSectionsToRender().forEach((section) => {
        sections.push(section.section);
      });
      dataWithSections.sections = sections;
    } else if (cartDrawer && task === 'add') {
      dataWithSections.sections = ['cart-drawer', 'cart-icon-bubble'];
    } else {
      dataWithSections.sections = [...(dataWithSections.sections || []), 'cart-icon-bubble'];
    }
  }
  var url = {
    add: '/cart/add',
    change: '/cart/change',
    update: '/cart/update',
    remove: '/cart/update',
    update_status: '/cart/update',
  };
  try {
    var response = await fetch(url[task], {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(dataWithSections),
    })
      .then(async (response) => {
        if (!response.ok) {
          let body = {};
          try {
            body = await response.json();
          } catch (_) {
            body = {};
          }
          throw Object.assign(new Error('cart-action-failed'), { status: response.status, body });
        }
        return response.json();
      })
      .then((response) => {
      if (task !== 'update_status') {
        handleButtonState(null, 'end');
        try {
          if (cartItems && response.sections) {
            const previousFeaturedCollectionIsAddForFreeShipping = !!document
              ?.getElementById('featured-collection')
              ?.querySelector('#add-for-free-shipping');
            cartItems.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);
              const newElement = cartItems.getSectionInnerHTML(response.sections[section.section], section.selector);
              elementToReplace.innerHTML = newElement;
              if (cartItems.handleEmptyCart) cartItems.handleEmptyCart(response);
              if (section.id === 'featured-collection') {
                const currentFeaturedCollectionIsAddForFreeShipping = !!document
                  ?.getElementById('featured-collection')
                  ?.querySelector('#add-for-free-shipping');
                if (previousFeaturedCollectionIsAddForFreeShipping === currentFeaturedCollectionIsAddForFreeShipping) {
                  document.getElementById('featured-collection')?.classList.add('disable-animation');
                } else {
                  document.getElementById('featured-collection')?.classList.remove('disable-animation');
                }
              }
              if (section.id === 'cart-cyot') {
                cartItems.initToggle();
              }
            });
          } else if (cartDrawer && task === 'add' && response.sections) {
            cartDrawer.renderContents(response);
          } else {
            dataWithSections.sections.forEach((section) => {
              const htmlText = response.sections[section];
              const html = new DOMParser()
                .parseFromString(htmlText, 'text/html')
                .querySelector('.shopify-section').innerHTML;
              const parentElement = document.getElementById(section);
              if (!parentElement) return;
              parentElement.innerHTML = html;
            });
          }
          if (data.id) {
            const variantId = data.id.toString().includes(':') ? data.id.split(':')[0] : data.id;
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: response, variantId: variantId });
          }
        } catch (renderError) {
          renderError.cartMutationSucceeded = true;
          throw renderError;
        }
      }
        return response;
      });
    return response;
  } catch (error) {
    if (options.propagate) {
      console.warn('cartAction: failed', {
        task,
        phase: error?.cartMutationSucceeded ? 'post-mutation-render' : 'cart-mutation',
        status: error?.status,
        body: error?.body,
        message: error?.message,
      });
    }
    if (options.propagate) throw error;
    console.error('Error:', error);
    return undefined;
  }
}

async function clearCart() {
  return await fetch('/cart/clear.js', {
    method: 'POST',
  })
    .then(function (response) {
      return response.json();
    })
    .catch(function (e) {
      console.warn(e.message);
    });
}

function handleButtonState(button, state) {
  if (!button) {
    document.querySelectorAll('.loading__spinner').forEach((spinner) => {
      const button = spinner.closest('button');
      if (button && !spinner.classList.contains('hidden')) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        button.removeAttribute('disabled');
      }
      spinner.classList.add('hidden');
    });
    return;
  }
  const loadingSpinner = button.querySelector('.loading__spinner');
  if (state === 'start') {
    button.setAttribute('aria-disabled', true);
    button.classList.add('loading');
    button.setAttribute('disabled', true);
    if (loadingSpinner) loadingSpinner.classList.remove('hidden');
  } else if (state === 'end') {
    button.removeAttribute('aria-disabled');
    button.classList.remove('loading');
    button.removeAttribute('disabled');
    if (loadingSpinner) loadingSpinner.classList.add('hidden');
  }
}

function showOneClickAddError(button) {
  if (!button) return;
  const message = button.dataset && button.dataset.errorVariantUnavailable;
  if (!message) return;
  const anchor = button.closest('.card__content') || button.parentElement || button;
  if (!anchor) return;
  let errorEl = anchor.querySelector(':scope > .cart-add-error');
  if (!errorEl) {
    errorEl = document.createElement('div');
    errorEl.className = 'cart-add-error';
    errorEl.setAttribute('role', 'alert');
    errorEl.setAttribute('aria-live', 'polite');
    errorEl.style.cssText = 'color:#EB001B;font-size:.875rem;margin-top:.5rem;text-align:center;';
    anchor.appendChild(errorEl);
  }
  errorEl.textContent = message;
  errorEl.style.display = 'block';
  clearTimeout(errorEl._dismissTimer);
  errorEl._dismissTimer = setTimeout(() => {
    errorEl.style.display = 'none';
  }, 4000);
}

// A one-click add reads the cart then adds, and the loading state locks only its own button, so
// two cards sharing a variant or umbrella can both read before either add lands. Holding a key
// across the read-and-add serialises them. The cart stays the backstop; this cap is not atomic.
const oneClickAddKeysInFlight = new Set();

async function productCardAddToCart(button) {
  const cyot = button.dataset.cyot;
  const carouselGpo = button.closest('.card__content').querySelector('a').dataset.gpo;
  const parsedDataSet = convertGPO(JSON.parse(carouselGpo));
  const variantId = parseInt(parsedDataSet.productVariant.id, 10);
  let limit = button.dataset.limit;
  let umbrellaLimitHandle = button.dataset.umbrellaLimitHandle;
  const heldKeys = [];

  handleButtonState(button, 'start');

  // finally releases the keys: one left behind refuses that variant for the page's life.
  try {
    if (limit) {
      limit = parseInt(limit, 10);
      if (umbrellaLimitHandle) umbrellaLimitHandle = umbrellaLimitHandle.replaceAll(' ', '-').toLowerCase();

      const keys = [`variant:${variantId}`];
      if (umbrellaLimitHandle) keys.push(`umbrella:${umbrellaLimitHandle}`);
      // Another add for this variant or umbrella is mid read-and-add, so any count read now is
      // about to be wrong. Drop the click silently; the first one is still working.
      if (keys.some((key) => oneClickAddKeysInFlight.has(key))) {
        handleButtonState(button, 'end');
        return;
      }
      keys.forEach((key) => {
        oneClickAddKeysInFlight.add(key);
        heldKeys.push(key);
      });

      const cart = await getCart();
      // getCart resolves undefined on a failed fetch; fall through and let the cart cap it.
      if (cart && cart.items) {
        let variantQuantity = 0;
        let umbrellaQuantity = 0;
        for (const item of cart.items) {
          // One variant can hold several lines, a CYOT line and a plain one, so sum them.
          if (item.id === variantId) variantQuantity += item.quantity;
          // Substring match, where product-purchase-state.liquid compares the umbrella metafield
          // exactly. /cart.js carries no product metafields, so a sibling can go uncounted.
          if (umbrellaLimitHandle && item.handle.includes(umbrellaLimitHandle)) {
            umbrellaQuantity += item.quantity;
          }
        }
        if (variantQuantity >= limit || umbrellaQuantity >= limit) {
          handleButtonState(button, 'end');
          renderLimitReachedModal('CustomModal-limit-reached');
          return;
        }
      }
    }

    const payload = {
      id: variantId,
      quantity: 1,
      sections: [],
    };
    if (cyot === 'true') {
      payload.properties = {
        _CYOT: 1,
      };
    }
    try {
      // propagate: true so the carousel button can surface a real error.
      await cartAction('add', payload, { propagate: true });
      handleFreeShippingCarouselAnalytics(parsedDataSet);
    } catch (error) {
      console.warn('productCardAddToCart: cart add failed', error);
      showOneClickAddError(button);
    }

    handleButtonState(button, 'end');
  } finally {
    heldKeys.forEach((key) => oneClickAddKeysInFlight.delete(key));
  }
}

function handleFreeShippingShopClick(event) {
  event.preventDefault();
  const href = event.target.getAttribute('href');
  if (href) {
    const element = document.getElementById(href.replace('#', ''));
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

function handleFreeShippingCarouselAnalytics(parsedDataSet) {
  const carousel = document.querySelector('.carousel-component#featured-collection');
  const carouselTitleEl = carousel ? carousel.querySelector('.title') : null;
  const carouselTitle = carouselTitleEl ? carouselTitleEl.textContent.trim() : '';

  if (parsedDataSet) {
    var segmentObject = {
      segmentType: 'track',
      trackName: 'Add to Cart from Cart Upsell Row',
      object: {
        productVariant: parsedDataSet,
      }
    };
    segmentEventPublish(segmentObject);
  }

  if (carousel && carousel?.querySelector('#add-for-free-shipping-non-dynamic')) {
    return;
  }

  let section = 'cart-featured-collection';
  if (carousel && carousel?.querySelector('#add-for-free-shipping')) {
    section = 'add-for-free-shipping';
  }
  const event = new CustomEvent('add-carousel-tracking', {
    detail: {
      carousel,
      carouselTitle,
      section,
    },
  });
  document.dispatchEvent(event);
}

function generateUuid() {
  const chars = [...'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'];
  const uuid = [...Array(32)].map(() => chars[(Math.random() * chars.length) | 0]).join``;
  return uuid;
}

function renderLimitReachedModal(modalID) {
  const templateID = modalID.replace('CustomModal-', '');
  const template = document.getElementById(templateID).content.cloneNode(true).firstElementChild;
  document.body.appendChild(template);
  if (!customElements.get('custom-modal')) customElements.define('custom-modal', CustomModal);
  const modal = document.getElementById(modalID);
  modal.show(null);
}

function convertGPO(gpo) {
  const firstVariant = gpo?.variants?.[0] || {};
  return {
    productVariant: {
      id: firstVariant?.id,
      image: {
        src: gpo.featured_image ? `https:${gpo.featured_image}` : firstVariant?.featured_image?.src,
      },
      price: firstVariant.price / 100,
      sku: firstVariant.sku,
      title: firstVariant.options?.length === 1 ? gpo.title : firstVariant.title,
      untranslatedTitle: firstVariant.options?.length === 1 ? gpo.title : firstVariant.title,
      product: {
        id: gpo.id,
        title: gpo.title,
        type: gpo.type,
        untranslatedTitle: gpo.title,
        url: window.location.href,
        vendor: gpo.vendor,
      }
    }
  };
}
function convertGPOForGA(gpo, stringifyId) {
  const firstVariant = gpo?.variants?.[0] || {};
  return {
    value: gpo.price / 100,
    currency: window.Shopify.currency.active,
    products: [{
      product_id: stringifyId ? gpo.id.toString() : gpo.id,
      sku: firstVariant.sku,
      category: gpo.type,
      name: firstVariant.options?.length === 1 ? gpo.title : firstVariant.title,
      brand: gpo.vendor,
      price: gpo.price / 100,
      url: `${window.location.origin}${gpo.url}`,
      image_url: gpo.featured_image ? `https:${gpo.featured_image}` : firstVariant?.featured_image?.src
    }]
  };
}

function convertCartGPO(gpo) {
  return {
    productVariant: {
      id: gpo?.variant_id,
      image: {
        src: gpo.featured_image ? `https:${gpo.featured_image.url}` : `https:${gpo.image}`,
      },
      price: gpo.price / 100,
      sku: gpo.sku,
      title: gpo?.variant_title || gpo.title,
      untranslatedTitle: gpo?.variant_title || gpo.title,
      product: {
        id: gpo.product_id,
        title: gpo.product_title,
        type: gpo.product_type,
        untranslatedTitle: gpo.product_title,
        url: window.location.href,
        vendor: gpo.vendor,
      }
    }
  };
}
function convertCartGPOForGA(gpo, stringifyId) {
  return {
    value: gpo.price / 100,
    currency: window.Shopify.currency.active,
    products: [{
      product_id: stringifyId ? gpo.id.toString() : gpo.id,
      sku: gpo.sku,
      category: gpo.product_type,
      name: gpo.product_title,
      brand: gpo.vendor,
      variant: gpo.variant_title,
      price: gpo.price / 100,
      quantity: gpo.quantity,
      coupon: gpo.discounts.length > 0 ? gpo.discounts[0].title : null,
      url: `${window.location.origin}${gpo.url}`,
      image_url: gpo.featured_image ? `https:${gpo.featured_image.url}` : gpo.image
    }]
  };
}

class TrunkEditButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('a');
    this.buttonText = this.querySelector('span');
    this.button.addEventListener('click', this.edit.bind(this));
  }
  async edit(e) {
    e.preventDefault();
    this.button.setAttribute('aria-disabled', true);
    this.button.setAttribute('disabled', true);
    this.querySelector('.loading__spinner').classList.remove('hidden');
    await cartAction('update_status', {
      attributes: {
        _cyot: 'loading',
      },
    });
    setTimeout(() => {
      window.location = this.button.href;
    }, 1000);
  }
}
customElements.define('trunk-edit-button', TrunkEditButton);

class FreeShippingMeter extends HTMLElement {
  linearMap(value, fromMin, fromMax, toMin, toMax) {
    return toMin + ((value - fromMin) * (toMax - toMin)) / (fromMax - fromMin);
  }

  constructor() {
    super();
    this.idx = this.dataset.idx ? this.dataset.idx : '';
    this.svg = this.querySelector('svg');
    if (!this.svg) {
      window.prevMeterClipX = null;
      window.prevMeterClipNegX = null;
      window.prevTrainTransform = null;
      return;
    }
    this.meterClip = this.svg.querySelector(`#meter-clip-${this.idx} rect`);
    this.meterClipNeg = this.svg.querySelector(`#meter-clip-negative-${this.idx} rect`);
    this.train = this.svg.querySelector('#TRAIN');
    if (!this.meterClip || !this.meterClipNeg || !this.train) {
      window.prevMeterClipX = null;
      window.prevMeterClipNegX = null;
      window.prevTrainTransform = null;
      return;
    }
    this.minPercent = 37;
    this.maxPercent = 82;
    this.minTranslate = -25;
    this.isCartSummary = !!this.closest('cart-items');
    if (!this.isCartSummary) {
      this.minPercent = 40;
      this.minTranslate = -21.75;
    }
    this.cartTotal = this.dataset.cartTotal ? parseInt(this.dataset.cartTotal) : 0;
    const freeShippingAmount = this.dataset.cartFreeShippingAmount
      ? parseInt(this.dataset.cartFreeShippingAmount)
      : null;

    if (freeShippingAmount && freeShippingAmount <= this.cartTotal) {
      this.setXOnClips(100, !!window.prevMeterClipX);
    } else if (freeShippingAmount === null) {
      this.setXOnClips(this.minPercent, false);
    } else {
      const cartProgress = (this.cartTotal / freeShippingAmount) * 100;
      const meterPosition = this.linearMap(cartProgress, 0, 100, this.minPercent, this.maxPercent);
      this.setXOnClips(meterPosition, true);
    }
  }
  setXOnClips(percent, animate = true) {
    if (window.prevMeterClipX && window.prevMeterClipNegX && window.prevTrainTransform) {
      this.meterClip.setAttribute('x', `${window.prevMeterClipX}%`);
      this.meterClipNeg.setAttribute('x', `${window.prevMeterClipNegX}%`);
      this.train.style.transform = `translateX(${window.prevTrainTransform}%)`;
    }
    if (!animate) {
      this.svg.classList.remove('transition');
    } else {
      this.svg.classList.add('transition');
    }

    const minPercent = this.minPercent;
    const maxPercent = 100;
    const minTranslate = this.minTranslate;
    let maxTranslate = 6;
    const clampedPercent = Math.max(minPercent, Math.min(percent, maxPercent));
    let translate = this.linearMap(clampedPercent, minPercent, maxPercent, minTranslate, maxTranslate);
    if (percent >= 100) {
      setTimeout(() => {
        window.prevMeterClipX = this.maxPercent;
        window.prevMeterClipNegX = this.maxPercent - 100;
        window.prevTrainTransform = translate;

        this.meterClip.setAttribute('x', `${this.maxPercent}%`);
        this.meterClipNeg.setAttribute('x', `${this.maxPercent - 100}%`);
        this.train.style.transform = `translateX(${translate}%)`;
      }, 0);

      return;
    }
    maxTranslate = 19;
    translate = this.linearMap(clampedPercent, minPercent, maxPercent, minTranslate, maxTranslate);

    const meterClipMinX = this.minPercent;
    const meterClipMaxX = 67.5;
    const trainMinTranslate = this.minTranslate;
    const trainMaxTranslate = 6;
    const meterClipX = this.linearMap(translate, trainMinTranslate, trainMaxTranslate, meterClipMinX, meterClipMaxX);

    setTimeout(() => {
      this.train.style.transform = `translateX(${translate}%)`;
      this.meterClip.setAttribute('x', `${meterClipX}%`);
      this.meterClipNeg.setAttribute('x', `${meterClipX - 100}%`);
      window.prevMeterClipX = meterClipX;
      window.prevMeterClipNegX = meterClipX - 100;
      window.prevTrainTransform = translate;
    }, 0);
  }
}
customElements.define('free-shipping-meter', FreeShippingMeter);

let __lockDepth = 0;
let __lockedScrollY = 0;

const __deferredPinReleases = [];

function handleScrollOnModalToggle(modalOpen, that, pinState = null) {
  if (modalOpen) {
    if (that.documentScrollTop) return true;
    that.documentScrollTop = true;

    if (__lockDepth === 0) {
      __lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

      document.body.style.position = 'fixed';
      document.body.style.top = `-${__lockedScrollY}px`;
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
    }
    __lockDepth += 1;
    return true;
  }

  if (!that.documentScrollTop) return true;

  if (__lockDepth > 1) {
    delete that.documentScrollTop;
    __lockDepth -= 1;
    if (pinState) __deferredPinReleases.push(pinState);
    return false;
  }

  if (pinState) unpinStickyAncestor(pinState);
  while (__deferredPinReleases.length) {
    unpinStickyAncestor(__deferredPinReleases.shift());
  }

  delete that.documentScrollTop;
  __lockDepth = 0;

  document.body.style.position = '';
  document.body.style.top = '';
  document.body.style.left = '';
  document.body.style.right = '';
  document.body.style.width = '';
  document.body.style.overflow = '';
  document.documentElement.style.overflow = '';

  const scrollY = __lockedScrollY;
  __lockedScrollY = 0;
  if (scrollY > 0) {
    document.documentElement.scrollTop = scrollY;
    document.body.scrollTop = scrollY;

    setTimeout(() => {
      if (window.pageYOffset === 0 && scrollY > 0) {
        window.scrollTo(0, scrollY);
      }
    }, 250);
  }
  return true;
}

function captureStickyAncestor(target) {
  const header = document.querySelector('.section-header');
  if (!header || !header.contains(target)) return null;
  return {
    header,
    beforeTop: header.getBoundingClientRect().top,
    prevTransform: header.style.transform,
    prevZIndex: header.style.zIndex,
  };
}

function pinStickyAncestor(state) {
  if (!state) return;
  state.header.style.zIndex = '12'; // Above mobile scrim (z-index 11) while body is fixed.

  const dy = state.beforeTop - state.header.getBoundingClientRect().top;
  if (Math.abs(dy) >= 0.5) {
    state.header.style.transform = `translateY(${dy}px)`;
  }
  state.applied = true;
}

function unpinStickyAncestor(state) {
  if (!state || !state.applied) return;
  state.header.style.transform = state.prevTransform || '';
  state.header.style.zIndex = state.prevZIndex || '';
  state.applied = false;
}

